import { ServerFetch } from '../main-model'

export default class InvoiceSupplierListModel extends ServerFetch {
    getAverageInvoiceSupplierListPriceByYearBy = (data) => this.authFetch({
        url: 'invoice-supplier-list/getAverageInvoiceSupplierListPriceByYearBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}